// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Confirm_wrapper__NHEpe","Container":"Confirm_Container__1jaMT","border":"Confirm_border__2doR3","close":"Confirm_close__xjN1y"};